import { render, staticRenderFns } from "./templateAdd.vue?vue&type=template&id=2b131551"
import script from "./templateAdd.vue?vue&type=script&lang=js"
export * from "./templateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports